var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"affiliates","space":"50"}},[_c('v-container',[_c('p',{staticClass:"text-center text-h3"},[_vm._v(" Kami berencana akan membuka jaringan layanan di beberapa kota besar di Indonesia ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }